/** Reads an FT3D debug flag, retaining legacy bookmarked review URLs. */
export function ft3dFlagParam(params: URLSearchParams, name: string): string | null {
  return params.get(`ft3d_${name}`) ?? params.get(`xz3d_${name}`);
}
